import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './TeamInfoStep.module.scss';

type SelectionChipProps = {
  label: ReactNode;
  icon?: ReactNode;
  selected?: boolean;
  onClick: () => void;
  testId?: string;
};

export const SelectionChip: FC<SelectionChipProps> = ({
  label,
  icon,
  selected = false,
  onClick,
  testId,
}) => (
  <button
    type="button"
    className={ classNames(styles.SelectionChip, { [styles.SelectionChipSelected]: selected }) }
    aria-pressed={ selected }
    onClick={ onClick }
    data-testid={ testId }
  >
    { icon && <span className={ styles.SelectionChipIcon }>{ icon }</span> }
    <span>{ label }</span>
  </button>
);
